/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconSync/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconSync({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconSync",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#8978F6"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconSync.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-Jqgv': alignSelf,'--mt-2-Jqgv': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Jqgv': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Jqgv': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Jqgv': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Jqgv': opacity,'--w-10-Jqgv': typeof width === 'number' ? `${width}px` : width,'--h-11-Jqgv': typeof height === 'number' ? `${height}px` : height,'--f-12-Jqgv': fill,'--a-7-Jqgv': isAnimated ? animation : "none",'--sd-8-Jqgv': isAnimated ? strokeDashoffset : 0,'--sd-9-Jqgv': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="TysiaIconSync.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_6132_13075)"
 className="views-block"
>
<path
  data-testid="TysiaIconSync.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M13.461 3.204l-.058-.008A3.205 3.205 0 0010.587.024C10.079-.038 9.168-.033 9.26.72a.625.625 0 00.697.544 1.96 1.96 0 012.187 1.756l-.16-.023a.625.625 0 00-.585.996l.635.841c.209.276.6.33.876.122l.84-.636a.625.625 0 00-.29-1.117zM8.36 1.612a.625.625 0 00-.876-.121l-.84.635a.625.625 0 00.29 1.118l.057.008a3.205 3.205 0 003.599 3.172.625.625 0 10-.153-1.24A1.96 1.96 0 018.25 3.427l.16.022a.625.625 0 00.585-.996l-.635-.84zM0 2.5A1.5 1.5 0 011.5 1H4a1 1 0 010 2H2v6h10V7.5a1 1 0 112 0v2a1.5 1.5 0 01-1.5 1.5H8.515l.537 1.5H10a.75.75 0 010 1.5H4a.75.75 0 010-1.5h.948l.537-1.5H1.5A1.5 1.5 0 010 9.5v-7z"
 style={{'--f-12-Jqgv': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}